import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'clipName',
  standalone: false,
})
export class ClipNamePipe implements PipeTransform {
  transform(name: string): string {
    return name.length > 33 ? `${name.substring(0, 32)}...` : name;
  }
}
